import { Card, CardBody, Col } from "reactstrap";
import CardHeaderCommon from "../../../../CommonElements/CommonCardHeader/CardHeaderCommon";
import { LatestSalesHeading } from "../../../../utils/Constant";
import LatestSalesTable from "./LatestSalesTable";

const LatestSales = () => {
  return (
    <Col xl="6" lg="6">
      <Card className="latest-sales">
        <CardHeaderCommon title={LatestSalesHeading}  />
        <CardBody className="pt-0">
          <LatestSalesTable />
        </CardBody>
      </Card>
    </Col>
  );
};

export default LatestSales;
